import React, { useState } from 'react';
import { BadgeMessage } from 'components/elements';
import { useTranslationX } from 'i18n';
import { Check } from 'components/icons';
import { Period } from '../Dashboard';
import { fromSQLTimestampToBrazilian } from 'utils/calendarUtils';
import styles from './PeriodItem.module.scss';

interface PeriodItemProps {
  periodo: Period;
  onToggle: (id: string) => Promise<boolean> | boolean;
  loading?: boolean;
  isSelected?: boolean;
}

const PeriodItem: React.FC<PeriodItemProps> = ({
  periodo,
  onToggle,
  loading = false,
  isSelected = false,
}) => {
  const { tx } = useTranslationX('dashboard', 'finance');
  const [localLoading, setLocalLoading] = useState(false);

  const handleToggle = async () => {
    setLocalLoading(true);
    try {
      const result = onToggle(periodo.id);
      if (result instanceof Promise) {
        await result;
      }
    } finally {
      setLocalLoading(false);
    }
  };

  const bank = tx('nonCovered.bank', {
    agencia: periodo.agencia,
    banco: periodo.banco,
    conta: periodo.conta,
  });

  const period = tx('nonCovered.period', {
    inicio: fromSQLTimestampToBrazilian(periodo.dataInicio.toString()),
    fim: fromSQLTimestampToBrazilian(periodo.dataFim.toString()),
  });

  const isLoading = loading || localLoading;

  return (
    <div className={styles.periodItem}>
      <div className={styles.badgeWrapper}>
        <BadgeMessage
          type="warning"
          text={`${periodo.identificacao}<br><br>${bank}<br><br>${period}`}
        />
        <button
          className={styles.finalizarButton}
          onClick={handleToggle}
          disabled={isLoading}
        >
          <div
            className={`${styles.checkbox} ${isLoading ? styles.loading : ''} ${
              isSelected ? styles.selected : ''
            }`}
          >
            {isLoading ? (
              <div className={styles.spinner} />
            ) : isSelected ? (
              <Check size={0.6} />
            ) : null}
          </div>
          <span>{tx('nonCovered.finalizar')}</span>
        </button>
      </div>
    </div>
  );
};

export default PeriodItem;
